import {Injectable} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  constructor() {
  }

  public goToNextStep(stepper: MatStepper): void {
    stepper._steps.forEach((value, i) => {
      if (i === stepper.selectedIndex) {
        value.editable = false;
      }
    });
    const icons = document.getElementsByClassName('mat-step-icon');
    icons[stepper.selectedIndex].setAttribute('style', 'background-color: #2eb872;');
    stepper.next();
  }

  public goToPreviousStep(stepper: MatStepper): void {
    stepper._steps.forEach((value, i) => {
      if (i === stepper.selectedIndex) {
        value.completed = false;
      }
      if (i === stepper.selectedIndex - 1) {
        value.editable = true;
      }
    });
    const icons = document.getElementsByClassName('mat-step-icon');
    icons[stepper.selectedIndex].setAttribute('style', 'background-color: #17479d;');
    stepper.previous();
  }

  public setNextButtonText(stepper: MatStepper): string {
    return stepper.selectedIndex !== stepper.steps.length - 1 ? 'Επόμενο' : 'Καταχώρηση';
  }

  public showPreviousButton(stepper: MatStepper): boolean {
    return stepper.selectedIndex > 0;
  }
}

